import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { EmployeeProfile } from "@/components/employees/employee-profile";
import { Link } from "@/core/lib/navigation";
import { useLabels } from "@/hooks/use-labels";
import { employeeQuery } from "@/lib/loaders";
import { Button } from "@/ui/components/ui/button";

export const Route = createFileRoute("/_workspace/employees/$id/")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(employeeQuery(params.id)),
  component: EmployeeProfilePage,
});

function EmployeeProfilePage() {
  const { id } = Route.useParams();
  const { tab } = Route.useSearch();
  const { data: employee } = useQuery(employeeQuery(id));

  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl">
        {employee ? <EmployeeProfile employee={employee} initialTab={tab} /> : <EmployeeNotFound />}
      </div>
    </main>
  );
}

function EmployeeNotFound() {
  const labels = useLabels();
  return (
    <div className="flex flex-col items-center justify-center gap-3 border border-dashed py-10 text-center">
      <p className="text-sm font-medium">{labels.people.singular} not found</p>
      <p className="text-sm text-muted-foreground">
        This {labels.people.lowerSingular} doesn’t exist or you don’t have access to it.
      </p>
      <Button asChild variant="outline">
        <Link href="/employees">Back to {labels.people.plural}</Link>
      </Button>
    </div>
  );
}
